(function() {
  document.addEventListener('DOMContentLoaded', function() {

    const projectImages = document.getElementsByClassName("gallery-item");
    if (!projectImages) return;

    const galleryImages = JSON.parse(
      document.getElementById('gallery-data')?.textContent || '[]'
    );

    const lightbox = document.querySelector('.gallery-lightbox');
    const lightboxWrapper = document.querySelector('.lightbox-images');
    const lightboxCounter = document.querySelector('.lightbox-counter');
    const closeBtn = document.querySelector('.lightbox-close');
    const prevBtn = document.querySelector('.lightbox-prev');
    const nextBtn = document.querySelector('.lightbox-next');
    const overlay = document.querySelector('.lightbox-overlay');
    let currentIndex = 0;

    // --- Render all image elements at once; src is assigned on demand in loadImage() ---
    if (lightboxWrapper && galleryImages.length > 0) {
      galleryImages.forEach((img, i) => {
        const imgEl = document.createElement('img');
        imgEl.dataset.src = img.url;
        imgEl.alt = img.alt;
        imgEl.decoding = 'async';
        imgEl.className = 'lightbox-image';
        imgEl.dataset.index = i;
        if (i !== 0) imgEl.style.display = 'none';
        lightboxWrapper.appendChild(imgEl);
      });
    }

    const imagesInLightbox = lightboxWrapper.querySelectorAll('.lightbox-image');

    function openLightbox(index) {
      currentIndex = index;
      updateLightbox();
      lightbox.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.style.display = 'none';
      document.body.style.overflow = '';
    }

    function loadImage(index) {
      const img = imagesInLightbox[index];
      if (img && !img.getAttribute('src')) img.src = img.dataset.src;
    }

    function updateLightbox() {
      loadImage(currentIndex);
      loadImage((currentIndex + 1) % imagesInLightbox.length);
      loadImage((currentIndex - 1 + imagesInLightbox.length) % imagesInLightbox.length);
      imagesInLightbox.forEach((img, i) => {
        img.style.display = i === currentIndex ? 'block' : 'none';
        if (i === currentIndex) {
            img.classList.remove('animate--slide-up-image');
            void img.offsetWidth; 
            img.classList.add('scroll-trigger', 'animate--slide-up-image');
        }
      });
      if (lightboxCounter)
        lightboxCounter.textContent = `${currentIndex + 1} / ${imagesInLightbox.length}`;
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % imagesInLightbox.length;
      updateLightbox();
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + imagesInLightbox.length) % imagesInLightbox.length;
      updateLightbox();
    }

    // --- Event Listeners ---
    document.querySelectorAll('.gallery-item').forEach(item => {
      item.addEventListener('click', function() {
        const index = parseInt(this.getAttribute('data-index'));
        openLightbox(index);
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
    if (overlay) overlay.addEventListener('click', closeLightbox);
    if (nextBtn) nextBtn.addEventListener('click', showNext);
    if (prevBtn) prevBtn.addEventListener('click', showPrev);

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (lightbox && lightbox.style.display === 'flex') {
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowRight') showNext();
        if (e.key === 'ArrowLeft') showPrev();
      }
    });
  });
})();
